module.exports = __webpack_public_path__ + "img/guide01.e01d32ca.png";